import { render, staticRenderFns } from "./onAppendButtonClick-editor.vue?vue&type=template&id=2175479c&scoped=true"
import script from "./onAppendButtonClick-editor.vue?vue&type=script&lang=js"
export * from "./onAppendButtonClick-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175479c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2175479c')) {
      api.createRecord('2175479c', component.options)
    } else {
      api.reload('2175479c', component.options)
    }
    module.hot.accept("./onAppendButtonClick-editor.vue?vue&type=template&id=2175479c&scoped=true", function () {
      api.rerender('2175479c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onAppendButtonClick-editor.vue"
export default component.exports